export default __webpack_public_path__ + "static/leftMob-1c20c9b9b80046b060fa2eb303440032.svg";